/**
 * Sentinel UUID used as class_id for "Alle Klassen" scope.
 * Separates Alle Klassen views/prefs from NULL (global default).
 */
export const ALLE_KLASSEN_SENTINEL = '00000000-0000-0000-0000-000000000000';

/**
 * Maps a classId from the UI ('' = Alle Klassen) to the DB value (sentinel UUID).
 * NULL means "no class context" (global default).
 */
export function classIdToDb(classId: string | null | undefined): string | null {
  if (classId === '') return ALLE_KLASSEN_SENTINEL;
  return classId || null;
}

/**
 * Maps a classId from the DB (sentinel UUID) back to the UI value ('' = Alle Klassen).
 */
export function classIdFromDb(classId: string | null): string {
  if (classId === ALLE_KLASSEN_SENTINEL) return '';
  return classId || '';
}

/** True when the Liste toolbar scope is „Alle Klassen“ (UI `''`, DB sentinel, or accidental `'ALL'`). */
export function isAlleKlassenKlassenlisteScope(selectedClass: string): boolean {
  return (
    selectedClass === '' ||
    selectedClass === ALLE_KLASSEN_SENTINEL ||
    selectedClass === 'ALL'
  );
}
